import { render } from "./BackToTopButton.vue?vue&type=template&id=ce5d228e&scoped=true&ts=true"
import script from "./BackToTopButton.vue?vue&type=script&lang=ts"
export * from "./BackToTopButton.vue?vue&type=script&lang=ts"

import "./BackToTopButton.vue?vue&type=style&index=0&id=ce5d228e&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce5d228e"]])

export default __exports__